export default "__VITE_ASSET__qtKoA8NO__"